import { Skeleton } from 'antd';
import { StyledWrapper } from './SubCategorySkeletonStyles';

type TSubCategorySkeleton = {
  level: number;
};

const SubCategorySkeleton = ({ level }: TSubCategorySkeleton) => {
  return (
    <StyledWrapper $level={level}>
      <Skeleton.Input active block />
      <Skeleton.Input active block />
      <Skeleton.Input active block />
    </StyledWrapper>
  );
};

export default SubCategorySkeleton;
